// The product name shown to users. Flipping it renames every page title at once (#585).
export const APP_NAME = 'Faro'

// Beacon → Faro (#585). Set to the day the rename ships; the bridge copy and the
// rename card run for a year after it, so seasonal users who skip a season still
// meet them. Accounts created on or after it never knew Beacon.
export const RENAME_DATE = Date.UTC(2026, 9, 23)
